"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_body_html_1 = __importDefault(require("./widget-body.html"));
(function (module) {
    'use strict';
    var PRODUCT_BASE_COMPONENT = 'pr.product-base-component';
    module.directive('prDividerBody', [
        'rsEnvironment',
        'rsWidgets',
        'prActiveReport',
        'prEventService',
        function (env, rsWidgets, activeReport, eventService) {
            return {
                restrict: 'E',
                templateUrl: widget_body_html_1.default,
                scope: false,
                link: function ($scope, $element) {
                    var wScope;
                    $element.on('$destroy', function destroy() {
                        $element.off('$destroy');
                        var widgetId = $scope.widget._id;
                        var pageId = activeReport.getPageIdOfWidget($scope.widget);
                        rsWidgets.unload(widgetId, pageId);
                        eventService.stream(widgetId).off('widgetSectionUpdated', loadBody);
                        $scope.$destroy();
                        $scope = null;
                        $element = null;
                        if (wScope) {
                            wScope.$destroy();
                            wScope = null;
                        }
                    });
                    loadBody();
                    eventService.stream($scope.widget._id).on('widgetSectionUpdated', loadBody);
                    function loadBody() {
                        var widget = $scope.widget;
                        var widgetId = widget._id;
                        var pageId = activeReport.getPageIdOfWidget(widget);
                        var children = $element.children();
                        children.empty();
                        var orientation = _.get(widget, 'state.privateData.orientation');
                        if (orientation) {
                            // add these attributes so dividers are resizable only in one direction
                            var widgetDiv = $element.closest('pr-widget');
                            widgetDiv.attr('resize', orientation === 'vertical' ? 'y' : 'x');
                        }
                        rsWidgets.ensureDependency(PRODUCT_BASE_COMPONENT).then(function () {
                            return rsWidgets.loadBody(widget._type, widgetId, children, null, pageId);
                        }).then(function () {
                            var containerId = env.get('containerId');
                            wScope = rsWidgets.getWidgetScope(widgetId, pageId, containerId);
                        });
                    }
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
